<template>
    <div>
        <base-modal :isOpen="value" :title="title" @close="close">
            <template #body>
                <div class="flex flex-col">
                    <label for="client">
                        {{ $t('client') | capitalize }}
                    </label>
                    <vs-input class="w-full" disabled v-model="item.ClientName"/>
                </div>

                <div class="flex flex-col mt-4">
                    <label for="hours">
                        {{ $t('days') | capitalize }}
                    </label>
                    <vs-input class="w-full" type="number" v-model="days" />
                </div>
                <vs-alert :active="alert" class="mt-4" color="warning">
                    Please enter a valid number of days.
                </vs-alert>
            </template>
            <template #footer>
                <div class="flex gap-4">
                    <vs-button color="danger" icon="close" type="flat" @click="close">
                        {{ $t('close') | upperCase }}
                    </vs-button>
                    <vs-button color="success" icon="save" type="flat" @click="save">
                        {{ $t('save') | upperCase }}
                    </vs-button>
                </div>

            </template>
        </base-modal>
    </div>

</template>

<script setup>
import { ref, watch, computed } from 'vue'
import BaseModal from '@/views/app/components/BaseModal.vue'
import { capitalize } from '../../../../../../utils/helpers'

const props = defineProps({
    value: { type: Boolean, default: false },
    title: { type: String, default: '' },
    item: { type: Object, default: () => ({ClientName:'',gracePeriod:1}) }

})

const emit = defineEmits(['click', 'input', 'save'])

const days = ref(1)

watch(() => props.value, (newValue) => {
    if (newValue) {
        days.value = props.item.gracePeriod
    }
})

const alert = computed(() => days.value <= 0 && days.value != '')

const close = () => {
    emit('input', false)
}

const validateDays = () => days.value <= 0

const save = () => {
    if (!validateDays) {
        console.log('Algunos correos no son válidos')
        return
    }
    const data = {
        client_id: props.item.ClientId,
        time: days.value * 24,
        gracePeriod: days.value
    }
    emit('save',data)
}


</script>

<style></style>